import { Action } from '@ngrx/store';
import { PaymentsPaginatorInterface } from '../../models/payments.paginator.interface';

export enum EPaymentsActions {
  GetPayments = '[PAYMENT] Get payments',
  GetPaymentsSuccess = '[PAYMENT] Get payments success',
  GetPaymentsFailure = '[PAYMENT] Get payments failure'
}

export class GetPayments implements Action {
  public readonly type = EPaymentsActions.GetPayments;
  constructor(public currentSelectedPage: number, public totalItemsPerPage: number) {}
}

export class GetPaymentsSuccess implements Action {
  public readonly type = EPaymentsActions.GetPaymentsSuccess;
  constructor(public payload: PaymentsPaginatorInterface) {}
}

export class GetPaymentsFailure implements Action {
  public readonly type = EPaymentsActions.GetPaymentsFailure;
}

export type PaymentsActions = GetPayments | GetPaymentsSuccess | GetPaymentsFailure;
